import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PlusCircle } from 'lucide-react';
import PropTypes from 'prop-types';

import OrderHistory from '@/components/common/icons/order-history.svg';
import renderSvg from '@/utils/renderSvg';
import InspectorRow from './InspectorRow';
import classes from './style.module.scss';

const InspectorsComponent = ({ inspectors, canAdd, orderId, refreshHandler }) => {
  const navigate = useNavigate();

  const goToAddInspector = () => {
    navigate(`/orders/${orderId}/performing-inspector`);
  };

  return (
    <div className={classes.inspectorsContainer}>
      <div className={classes.header}>
        {renderSvg(OrderHistory, {
          alt: '',
          className: classes.icon,
        })}
        <FormattedMessage id="PERFORMING_INSPECTORS" defaultMessage="Vistoriadores executantes" />
      </div>

      {inspectors.length > 0 && (
        <div className={classes.timeline}>
          <div className={classes.title}>
            <div style={{ width: '35%', paddingLeft: '8px' }}>
              <FormattedMessage id="ACTION" defaultMessage="Ação" />
            </div>
            <div style={{ width: '35%' }}>
              <FormattedMessage id="INSPECTOR" defaultMessage="Vistoriador" />
            </div>
            <div style={{ width: '20%' }}>
              <FormattedMessage id="DATE_AND_TIME" defaultMessage="Data e Hora" />
            </div>
            <div style={{ width: '10%' }}></div>
          </div>

          {inspectors.map((inspector, index) => (
            <InspectorRow
              inspector={inspector}
              key={`${inspector.public_id}-${index}`}
              orderId={orderId}
              refreshHandler={refreshHandler}
              isLast={index === inspectors.length - 1}
            />
          ))}
        </div>
      )}

      {canAdd && (
        <div className="my-[1vw] pl-[calc(14px+1.8vw)]">
          <button
            type="button"
            className="flex items-center gap-[0.5vw] text-[calc(5px+0.4vw)] text-[#007BFF] hover:text-[#0056b3] hover:underline cursor-pointer bg-none border-none p-0 transition-colors"
            onClick={goToAddInspector}
            data-cy="order-details-add-inspector"
          >
            <PlusCircle className="w-[calc(10px+0.4vw)] h-[calc(10px+0.4vw)]" />
            <FormattedMessage id="ADD_INSPECTOR" />
          </button>
        </div>
      )}
    </div>
  );
};

InspectorsComponent.propTypes = {
  inspectors: PropTypes.array,
  canAdd: PropTypes.bool.isRequired,
  orderId: PropTypes.string.isRequired,
  refreshHandler: PropTypes.func.isRequired,
};

InspectorsComponent.defaultProps = {
  inspectors: [],
};

export default InspectorsComponent;
